<template>
    <div class="foot">
      <!-- Copyright © 2019 织金洞联合国教科文世界地质公园 版权所有  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 黔ICP备15015958号 -->
      <div data-v-375afe18="" class="d_footer_tk_content" style="font-size: 14px;">
        <div data-v-375afe18="" class="flex-cc">Copyright © 2021 贵州织金洞旅游开发有限责任公司. All Rights Reserved. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;旅游咨询热线：4000-520-887</div> 
        <div data-v-375afe18="" class="flex-cc"><img data-v-375afe18="" src="static/img/policeicon.d0289dc.png"> 公安备案号：<a data-v-375afe18="" id="icL" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=52052402000115" target="_blank">贵公网安备52052402000115号</a>
        &nbsp;&nbsp;&nbsp;&nbsp;
        ICP备案号：<a data-v-375afe18="" id="icL" href="http://beian.miit.gov.cn" target="_blank">黔ICP备15015958号</a></div> 
        <div data-v-375afe18="" class="flex-cc">技术支持：联通数字科技有限公司贵州省分公司&nbsp;</div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'foot',
  data () {
    return {
      
    }
  },
  props:{

  },
  computed:{

  },
  watch:{

  },
  activated(){

  },
  deactivated(){

  },
  created(){

  },
  mounted(){
    
  },
  methods:{

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.foot{
width: 100%;background: #000;text-align: center;font-size: 20px;color: #999;padding: 15px 0;line-height: 30px;font-size: 16px;
div a{color: #999;}
div a:hover{color: #fff;}
div{font-size: 16px;}
}
</style>



// WEBPACK FOOTER //
// src/components/foot.vue